import { IKeHoachKyHieuActionTypes } from "../../action-types/ke-hoach/IKeHoachKyHieuActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachKyHieuReducer } from "../../reducer-model/ke-hoach/IKeHoachKyHieuReducer";
const iniState: IKeHoachKyHieuReducer = {
  status: eReducerStatusBase.is_not_initialization,
  kyHieus: []
};
export const keHoachKyHieuReducer = (
  state: IKeHoachKyHieuReducer = iniState,
  action: IKeHoachKyHieuActionTypes
): IKeHoachKyHieuReducer => {
  switch (action.type) {
    case "KE_HOACH_KY_HIEU_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KE_HOACH_KY_HIEU_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        kyHieus: action.payload,
      };
    case "KE_HOACH_KY_HIEU_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };

    default:
      return state;
  }
};
